import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SidebarContainer from '../SidebarContainer';
import DealerNav from '../../components/DealerNav';
import LoadingOverlay from '../../components/LoadingOverlay';
import dealersActions from '../../redux/dealers/actions';
import { getTmpDealer } from '../../redux/dealers/selectors';
import { AppointmentList } from '../../components/AppointmentList/AppointmentList';
import ContentPage from '../ContentPage';
import ErrorMessage from '../../components/ErrorMessage';

function Appointments({
  actions,
  dealer,
  error,
  tmpDealer,
  history,
  fetching,
}) {
  return (
    <SidebarContainer title="Appointments" logo={dealer.logo}>
      <div className="dealers-table">
        <DealerNav />
        {error && <ErrorMessage error={error} />}
        <div className="accessories-container">
          <LoadingOverlay active={fetching}>
            {dealer && dealer.id && (
              <AppointmentList
                actions={actions}
                dealer={dealer}
                tmpDealer={tmpDealer}
                history={history}
              />
            )}
          </LoadingOverlay>
        </div>
      </div>
    </SidebarContainer>
  );
}

Appointments.propTypes = {
  actions: PropTypes.object,
  dealer: PropTypes.object,
  tmpDealer: PropTypes.object,
  history: PropTypes.object,
  fetching: PropTypes.bool,
};

const mapStateToProps = state => ({
  dealer: state.dealers.dealer,
  error: state.dealers.error,
  tmpDealer: getTmpDealer(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...dealersActions,
    },
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentPage(Appointments));
